export default {
  header: 'Informácie o peci',
  text: 'Text',
  bgColor: 'Farba pozadia',
};
